<ion-footer>
  <div class="crossIcon" (click)="cancel()">
    <ion-icon name="close-outline"></ion-icon>
  </div>
  <div class="dates-header" *ngIf="!scheduleTime">
    <p class="header">
      {{'scheduleDelivery' | language : 'Schedule Delivery'}}</p>
    <ion-grid *ngIf="openCalendar">
      <ion-row color="primary">
        <ion-col size="4" size-sm="2" size-md="2" size-lg="2">
          <ion-card color="warning" [disabled]="product?.status === 'available_tomorrow' || hideNow" class="box" (click)="setDeliverySlotNow()">
            <div class="content">
              <ion-img src="assets/schedule/now.svg"></ion-img>
              <p> {{'Now' | language : 'Now'}} </p>
            </div>
          </ion-card>
        </ion-col>
        <ion-col size="4" size-sm="2" size-md="2" size-lg="2" *ngFor="let item of data; let i = index">
          <ion-card color="warning" class="box" [disabled]="product?.status === 'available_tomorrow' && i < 1" (click)="setDeliverySlot(item)">
            <div class="content">
              <ng-container [ngSwitch]="i">
                <ng-container *ngSwitchCase="0">
                  <ion-img src="assets/schedule/today.svg"></ion-img>
                </ng-container>
                <ng-container *ngSwitchCase="1">
                  <ion-img src="assets/schedule/tomorrow.svg"></ion-img>
                </ng-container>
                <ng-container *ngSwitchCase="2">
                  <ion-img src="assets/schedule/day-after-tomorrow.svg"></ion-img>
                  <span class="date-overlay">
                    {{ dayAfterTomorrowDate }}
                  </span>
                </ng-container>
                <ng-container *ngSwitchCase="3">
                  <ion-img src="assets/schedule/day-after-tomorrow.svg"></ion-img>
                  <span class="date-overlay">
                    {{ twoDaysAfterTomorrowDate }}
                  </span>
                </ng-container>
              </ng-container>
              <p>{{getDate(item)}}</p>
            </div>
          </ion-card>
        </ion-col>
        <ion-col size="4" size-sm="2" size-md="2" size-lg="2">
          <ion-card color="warning" (click)="hide()" class="box">
            <div class="content">
              <ion-img src="assets/schedule/more.svg"></ion-img>
              <p> {{'more' | language : 'More'}} </p>
            </div>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-datetime *ngIf="!openCalendar" presentation="date" (ionChange)="setDeliverySlot(selectedDate)"
      [(ngModel)]="selectedDate" [min]="todayDate"></ion-datetime>
  </div>
</ion-footer>
